export default {
  "content": "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M9.315 2.695A.75.75 0 0110 2.25h6a.75.75 0 01.67 1.085L14.214 8.25H17a.75.75 0 01.6 1.2l-9 12a.75.75 0 01-1.332-.613l1.797-8.087H6a.75.75 0 01-.685-1.055l4-9zm1.172 1.055l-3.333 7.5H10a.75.75 0 01.732.913l-1.245 5.605L15.5 9.75H13a.75.75 0 01-.67-1.085l2.457-4.915h-4.3z\" fill=\"#6F7488\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};